module.exports = __webpack_public_path__ + "img/logo.0d9e11fc.png";